module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./StudioApplyPromiseView.js"));
	}, "StudioApplyPromiseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StudioApplyPromiseView!./src/pages/Shop/Member/Agreements/StudioApplyPromise/StudioApplyPromiseView.js
// module id = 967
// module chunks = 431